/* Gooseberry Fit Finder — shared engine for the product-page popup and the fit guide page.
   Charts come from Shopify metaobjects (type: size_chart) rendered into JSON by Liquid.
   Each chart: { handle, name, collection, style, category, decides, oneSize, cols:{ub,ob,wa,hi,bra}, garment }
   where cols.* is the raw multi-line text "XS 80-85\nS 85-92…" — parsed here. */
(function () {
  "use strict";

  var ORDER = ["XS", "S", "M", "L", "XL"];
  var MNAME = { ob: "Over bust", ub: "Under bust", wa: "Waist", hi: "Hip" };
  var MINFO = {
    ob: "Around your back and across the fullest part of your chest, tape level and snug.",
    ub: "Directly under the bust, snug against the ribcage.",
    wa: "The narrowest part of your torso, usually just above the navel.",
    hi: "Feet together, around the fullest part of your hips and seat."
  };
  var KEYORDER = ["ob", "ub", "wa", "hi"];
  var STORE_KEY = "gb_measure_profile_v1";
  var DECIDES = { "Over bust": "ob", "Hips": "hi", "Waist": "wa" };

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function load() { try { var r = window.localStorage.getItem(STORE_KEY); if (!r) return null; var d = JSON.parse(r); return (d && d.m) ? d : null; } catch (e) { return null; } }
  function save(profile) { try { window.localStorage.setItem(STORE_KEY, JSON.stringify({ m: profile.m || {}, email: profile.email || null, consent: !!profile.consent, at: Date.now() })); } catch (e) { } }
  function clearStore() { try { window.localStorage.removeItem(STORE_KEY); } catch (e) { } }
  function list(names) { if (names.length === 1) return names[0]; return names.slice(0, -1).join(", ") + " and " + names[names.length - 1]; }

  /* ---- parse "XS 80-85" columns into {XS:[80,85], …} ---- */
  function parseCol(text) {
    var out = {};
    String(text || "").split(/\r?\n/).forEach(function (line) {
      var m = line.trim().match(/^([A-Za-z\/]+)\s+(\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)$/);
      if (m) out[m[1].toUpperCase()] = [parseFloat(m[2].replace(",", ".")), parseFloat(m[3].replace(",", "."))];
    });
    return out;
  }
  function parseText(text) {
    var out = {};
    String(text || "").split(/\r?\n/).forEach(function (line) {
      var m = line.trim().match(/^([A-Za-z\/]+)\s+(.+)$/);
      if (m) out[m[1].toUpperCase()] = m[2].trim();
    });
    return out;
  }
  /* normalise a raw chart into rows + keys */
  function prep(c) {
    if (c._prepared) return c;
    var cols = { ub: parseCol(c.cols.ub), ob: parseCol(c.cols.ob), wa: parseCol(c.cols.wa), hi: parseCol(c.cols.hi) };
    var bra = parseText(c.cols.bra);
    var sizes = {};
    KEYORDER.forEach(function (k) { Object.keys(cols[k]).forEach(function (s) { sizes[s] = 1; }); });
    Object.keys(bra).forEach(function (s) { sizes[s] = 1; });
    var order = ORDER.concat(["OS", "XS/S", "M/L"]);
    c.rows = Object.keys(sizes).sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); }).map(function (s) {
      var r = { size: s };
      KEYORDER.forEach(function (k) { if (cols[k][s]) r[k] = cols[k][s]; });
      if (bra[s]) r.bra = bra[s];
      return r;
    });
    c.keys = KEYORDER.filter(function (k) { return c.rows.some(function (r) { return !!r[k]; }); });
    c.primary = c.oneSize ? null : (DECIDES[c.decides] || null);
    if (c.primary && !c.keys.some(function (k) { return k === c.primary; })) c.primary = null;
    c.split = !c.oneSize && !c.primary && /XS\/S|M\/L/i.test(c.garment || "");
    c._prepared = true;
    return c;
  }
  function sizeFor(c, key, cm) {
    var rows = c.rows.filter(function (r) { return !!r[key] && ORDER.indexOf(r.size) >= 0; }); if (!rows.length) return null;
    var hits = rows.filter(function (r) { return cm >= r[key][0] && cm <= r[key][1]; });
    if (hits.length) return hits[hits.length - 1];
    if (cm < rows[0][key][0] || cm > rows[rows.length - 1][key][1]) return null;
    for (var j = 0; j < rows.length; j++) { if (cm < rows[j][key][0]) return rows[j]; }
    return null;
  }

  /* ---- data capture (Omnisend storefront JS, if present) ---- */
  function capture(email, consent, m, extra) {
    try {
      var payload = { email: email };
      if (consent) payload.status = "subscribed";
      var props = { over_bust_cm: m.ob, under_bust_cm: m.ub, waist_cm: m.wa, hip_cm: m.hi };
      window.omnisend = window.omnisend || [];
      if (typeof window.omnisend.identifyContact === "function") window.omnisend.identifyContact(payload);
      else window.omnisend.push(["identifyContact", payload]);
      window.omnisend.push(["track", "$custom", Object.assign({ eventName: "Fit finder", email: email }, props, extra || {})]);
    } catch (e) { }
    try { document.dispatchEvent(new CustomEvent("gb:fit-finder:save", { detail: { email: email, consent: consent, measurements: m, extra: extra } })); } catch (e) { }
  }

  /* =========================================================
     Shared UI pieces
     ========================================================= */
  function unitsHTML(state) {
    return '<div class="gbf-units" role="group" aria-label="Units"><button type="button" data-unit="cm" aria-pressed="' + (state.unit === "cm") + '">cm</button><button type="button" data-unit="in" aria-pressed="' + (state.unit === "in") + '">in</button></div>';
  }
  function fieldsHTML(state, keys) {
    return '<div class="gbf-fields">' + keys.map(function (k) {
      var v = state.m[k], o = !!state.open[k];
      return '<div class="gbf-field"><span class="gbf-lab"><label for="gbf-in-' + k + '">' + MNAME[k] + '</label><button type="button" class="gbf-info" data-info="' + k + '" aria-expanded="' + o + '" aria-label="How to measure ' + MNAME[k].toLowerCase() + '">i</button></span>' +
        '<span class="gbf-inrow"><input id="gbf-in-' + k + '" type="text" inputmode="decimal" autocomplete="off" data-key="' + k + '" value="' + (v != null ? toDisplay(state, v) : "") + '"><span class="gbf-unit">' + state.unit + '</span></span>' +
        (o ? '<p class="gbf-infotext">' + MINFO[k] + '</p>' : '') + '</div>';
    }).join("") + '</div>';
  }
  function captureHTML(state, show, sub) {
    if (state.profile || !show) return "";
    return '<div class="gbf-capture"><p class="gbf-cap-title ff-heading">Remember my size</p><p class="gbf-cap-sub">' + sub + '</p>' +
      '<div class="gbf-cap-row"><input type="email" class="gbf-email" placeholder="Email address" aria-label="Email address"><button type="button" class="gbf-save">Save</button></div>' +
      '<label class="gbf-consent"><input type="checkbox" class="gbf-consent-box"><span>Email me about new arrivals and restocks. Unsubscribe any time.</span></label></div>';
  }
  /* note shown only when a saved profile actually covers the measurements this chart asks for */
  function noteHTML(state, keys) {
    if (!state.profile) return "";
    var has = keys.some(function (k) { return state.m[k] != null; });
    if (!has) return "";
    var text = state.justSaved ? "Saved. We’ll use these next time." : "Using your saved measurements.";
    return '<div class="gbf-saved"><span>' + text + '</span><button type="button" class="gbf-link gbf-forget">Forget my measurements</button></div>';
  }
  function toDisplay(state, cm) { return state.unit === "cm" ? Math.round(cm * 10) / 10 : Math.round((cm / 2.54) * 10) / 10; }
  function toCm(state, v) { var n = parseFloat(String(v).replace(",", ".")); if (!isFinite(n)) return null; return state.unit === "cm" ? n : n * 2.54; }
  function csHTML(url, text) { return '<p class="gbf-line gbf-cs">' + text + ' <a href="' + esc(url) + '">Reach out to us</a> and we’ll find the right fit for you.</p>'; }

  /* controls that live above the result: units, info toggles, inputs. Bound once per render(). */
  function bindTop(root, state, rerender, rerenderOut, extra) {
    root.querySelectorAll("[data-unit]").forEach(function (b) { b.addEventListener("click", function () { if (state.unit === b.getAttribute("data-unit")) return; state.unit = b.getAttribute("data-unit"); rerender(); }); });
    root.querySelectorAll("[data-info]").forEach(function (b) {
      b.addEventListener("click", function () {
        var k = b.getAttribute("data-info"), field = b.closest(".gbf-field"), open = b.getAttribute("aria-expanded") === "true";
        state.open[k] = !open; b.setAttribute("aria-expanded", String(!open));
        var p = field.querySelector(".gbf-infotext");
        if (open && p) p.parentNode.removeChild(p);
        if (!open && !p) { p = document.createElement("p"); p.className = "gbf-infotext"; p.textContent = MINFO[k]; field.appendChild(p); }
      });
    });
    root.querySelectorAll("input[data-key]").forEach(function (inp) {
      inp.addEventListener("input", function () {
        var cm = toCm(state, inp.value), k = inp.getAttribute("data-key");
        if (cm == null) delete state.m[k]; else state.m[k] = cm;
        if (state.profile) { /* already opted in: keep the profile current, no second ask */
          state.profile.m = state.m; state.justSaved = true; save(state.profile);
          clearTimeout(state._t); state._t = setTimeout(function () { if (state.profile.email) capture(state.profile.email, state.profile.consent, state.m, extra ? extra() : null); }, 2000);
        }
        rerenderOut();
      });
    });
  }
  /* controls that live inside the result area: save, forget. Bound once per renderOut(). */
  function bindOut(root, state, rerender, rerenderOut, extra) {
    var sv = root.querySelector(".gbf-save"); if (sv) sv.addEventListener("click", function () {
      var e = root.querySelector(".gbf-email").value.trim(); if (!e || e.indexOf("@") < 1) { root.querySelector(".gbf-email").focus(); return; }
      var consent = !!(root.querySelector(".gbf-consent-box") || {}).checked;
      state.profile = { m: state.m, email: e, consent: consent }; state.justSaved = true;
      save(state.profile); capture(e, consent, state.m, extra ? extra() : null);
      rerenderOut();
    });
    var fg = root.querySelector(".gbf-forget"); if (fg) fg.addEventListener("click", function () { clearStore(); state.m = {}; state.profile = null; state.justSaved = false; rerender(); });
  }
  function initState() {
    var state = { unit: "cm", m: {}, open: {}, profile: null, justSaved: false };
    var prior = load();
    if (prior && prior.m) { state.m = prior.m; state.profile = { m: prior.m, email: prior.email || null, consent: !!prior.consent }; }
    return state;
  }

  /* ---- order attribution ----
     Hidden line-item properties on this product's add-to-cart form. They travel with the item into the order
     (underscore prefix = not shown to the customer, same convention the theme uses for _gwp_eligible / _byob__base_price)
     so Shopify Flow can tag the order and returns can be compared per item. */
  var LINE_PROPS = {}; /* handle -> current properties, for pages that add to cart via JS instead of a form */
  function stampForm(handle, props) {
    var cur = LINE_PROPS[handle] || (LINE_PROPS[handle] = {});
    Object.keys(props).forEach(function (k) { if (props[k] == null) delete cur[k]; else cur[k] = props[k]; });
    document.querySelectorAll('form[data-product-form][data-product-handle="' + handle + '"]').forEach(function (form) {
      Object.keys(props).forEach(function (k) {
        var name = "properties[" + k + "]", inp = form.querySelector('input[name="' + name + '"]');
        if (props[k] == null) { if (inp) inp.parentNode.removeChild(inp); return; }
        if (!inp) { inp = document.createElement("input"); inp.type = "hidden"; inp.name = name; form.appendChild(inp); }
        inp.value = props[k];
      });
    });
  }
  /* Cart-level attribute for the landing page (there is no product form to stamp there). */
  function stampCart(attrs) {
    try { fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ attributes: attrs }) }); } catch (e) { }
  }

  /* =========================================================
     Product page popup
     ========================================================= */
  function mountProduct(cfg) {
    var chart = prep(cfg.chart), root = cfg.root, scrim = cfg.scrim, state = initState();
    var extra = function () { var r = compute(); return { product: cfg.productTitle, chart: chart.handle, recommended_size: r.row ? r.row.size : null }; };
    var csUrl = cfg.contactUrl || "/pages/contact";

    function compute() {
      if (chart.oneSize) return { kind: "onesize" };
      if (!chart.primary) return { kind: "split" };
      /* wait until every measurement this chart asks for is filled in */
      if (chart.keys.some(function (k) { return state.m[k] == null; })) return { kind: "empty" };
      var cm = state.m[chart.primary];
      var row = sizeFor(chart, chart.primary, cm); if (!row) return { kind: "none" };
      return { kind: "size", row: row };
    }
    function resultHTML() {
      var r = compute();
      if (r.kind === "onesize") return '<div class="gbf-result"><div class="gbf-size gbf-size--sm ff-heading">One size</div><p class="gbf-line">This piece is cut in a single size — nothing to work out.</p></div>';
      if (r.kind === "split") return '<div class="gbf-result"><div class="gbf-size gbf-size--sm ff-heading">Two sizes</div><p class="gbf-line">This piece comes in two sizes rather than four. Compare the garment measurements below with something you already own.</p><div class="gbf-split">' +
        String(chart.garment || "").split(/\r?\n/).filter(Boolean).map(function (line) { var i = line.indexOf(":"); var sz = i > 0 ? line.slice(0, i) : "", rest = i > 0 ? line.slice(i + 1) : line; return '<div class="gbf-split-row"><span class="gbf-split-size ff-heading">' + esc(sz.trim()) + '</span><span class="gbf-split-spec">' + esc(rest.trim()) + '</span></div>'; }).join("") + '</div></div>';
      if (r.kind === "empty") return "";
      if (r.kind === "none") return '<div class="gbf-result">' + csHTML(csUrl, "We don’t have a true size for that measurement.") + '</div>';
      var h = '<div class="gbf-result"><div class="gbf-size ff-heading">' + esc(r.row.size) + '</div>';
      if (r.row.bra) h += '<p class="gbf-conv"><span>Roughly</span>' + esc(r.row.bra) + '</p>';
      h += '<button type="button" class="gbf-btn" data-pick="' + esc(r.row.size) + '">Select ' + esc(r.row.size) + '</button></div>';
      return h;
    }
    function render() {
      root.innerHTML = '<p class="gbf-eyebrow">Find your size</p><h2 class="gbf-title ff-heading" id="gbf-title">' + esc(cfg.productTitle) + '</h2>' +
        (chart.primary ? unitsHTML(state) + fieldsHTML(state, chart.keys) : "") + '<div class="gbf-out"></div>';
      bindTop(root, state, render, renderOut, extra);
      renderOut();
    }
    function renderOut() {
      var o = root.querySelector(".gbf-out"); if (!o) return;
      var r = compute();
      /* the email ask appears once there is a size to remember */
      o.innerHTML = resultHTML() + noteHTML(state, chart.keys) + captureHTML(state, r.kind === "size", "We’ll skip this next time, and send 10% off your first order. Optional.");
      if (cfg.productHandle) {
        var sel = document.querySelector('form[data-product-handle="' + cfg.productHandle + '"] input[name="properties[_fit_finder_selected]"]');
        var selVal = sel ? sel.value : (LINE_PROPS[cfg.productHandle] || {})._fit_finder_selected; /* JS-cart pages keep it in LINE_PROPS */
        var keepSel = r.kind === "size" && selVal === r.row.size; /* drop the "selected" flag if the recommendation has since changed */
        stampForm(cfg.productHandle, { _fit_finder: r.kind === "size" ? r.row.size : null, _fit_finder_selected: keepSel ? selVal : null });
      }
      var pk = root.querySelector("[data-pick]"); if (pk) pk.addEventListener("click", function () { if (cfg.productHandle) stampForm(cfg.productHandle, { _fit_finder_selected: pk.getAttribute("data-pick") }); selectVariant(pk.getAttribute("data-pick")); close(); });
      bindOut(root, state, render, renderOut, extra);
    }
    function selectVariant(size) {
      /* The theme renders the Size option as chips: button.product__chip[data-option-value] inside [data-option-buttons].
         Clicking the chip drives ProductForm; fall back to the hidden <select name="options[Size]"> if chips are absent. */
      var done = false, want = size.toUpperCase();
      /* theme chips (.product__chip[data-option-value]) or the CRO PDP's size pills ([data-gb-size][data-value]) */
      document.querySelectorAll('.product__chip[data-option-value], [data-gb-size][data-value]').forEach(function (el) {
        if (done) return;
        var v = el.getAttribute("data-option-value") || el.getAttribute("data-value") || "";
        if (v.trim().toUpperCase() === want) { el.click(); done = true; }
      });
      if (!done) {
        var sel = document.querySelector('select[name="options[Size]"], select[name="options[size]"]');
        if (sel) { for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value.trim().toUpperCase() === want) { sel.selectedIndex = i; sel.dispatchEvent(new Event("change", { bubbles: true })); done = true; break; } } }
      }
      try { document.dispatchEvent(new CustomEvent("gb:fit-finder:select", { detail: { size: size, applied: done } })); } catch (e) { }
    }
    function open() { render(); scrim.classList.add("is-open"); scrim.removeAttribute("hidden"); document.body.classList.add("gbf-lock"); var f = root.querySelector("input[data-key]"); if (f && !f.value) f.focus(); }
    function close() { scrim.classList.remove("is-open"); scrim.setAttribute("hidden", ""); document.body.classList.remove("gbf-lock"); }
    /* "under_size" placement: sit on the Size label line, to the right, next to the Kiwi "Size Chart" link:
       Size: XS                      Size Chart | Find my size
       (the theme only re-renders the media column on variant change, so this sticks) */
    document.querySelectorAll("[data-gbf-under-size]").forEach(function (wrap) {
      var sel = document.querySelector('.product__option select[name="options[Size]"], .product__option select[name="options[size]"]');
      var opt = sel && sel.closest(".product__option");
      if (opt) {
        var links = document.createElement("div"); links.className = "gbf-size-links";
        var label = opt.querySelector(".product__label-wrapper");
        if (label) label.insertAdjacentElement("afterend", links); else opt.insertAdjacentElement("afterbegin", links);
        var kiwi = opt.querySelector("#KiwiSizingChart");
        if (kiwi) { links.appendChild(kiwi); var sep = document.createElement("span"); sep.className = "gbf-size-sep"; sep.setAttribute("aria-hidden", "true"); sep.textContent = "|"; links.appendChild(sep); }
        links.appendChild(wrap);
        opt.classList.add("gbf-size-row");
      }
      wrap.removeAttribute("hidden");
    });
    /* delegated, so the row keeps working if the theme re-renders the product section (variant change, quick add) */
    document.addEventListener("click", function (e) { var t = e.target.closest && e.target.closest("[data-gbf-open]"); if (t) { e.preventDefault(); open(); } });
    scrim.addEventListener("click", function (e) { if (e.target === scrim) close(); });
    var x = scrim.querySelector(".gbf-close"); if (x) x.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && scrim.classList.contains("is-open")) close(); });
  }

  /* =========================================================
     Fit guide page (all charts, by category)
     ========================================================= */
  function mountGuide(cfg) {
    var charts = cfg.charts.map(prep), root = cfg.root, state = initState(), zone = "Tops";
    var extra = function () { var r = compute(); return { page: "fit-guide", category: zone, recommended_size: r.size || null }; };
    var ZKEY = { "Tops": "ob", "Bottoms": "hi", "One-pieces": "ob" };
    var ZNOUN = { "Tops": "tops", "Bottoms": "bottoms", "One-pieces": "one-piece swimwear and bodysuit lingerie" };
    var ALL = ["ob", "ub", "wa", "hi"];
    var csUrl = cfg.contactUrl || "/pages/contact";

    function compute() {
      var k = ZKEY[zone], cm = state.m[k];
      /* all four measurements before a size is shown */
      if (ALL.some(function (x) { return state.m[x] == null; })) return { kind: "empty", key: k };
      var groups = {}, onesize = [], bra = null;
      charts.forEach(function (c) {
        if (c.category !== zone) return;
        if (c.oneSize) { onesize.push(c.name); return; }
        if (c.primary !== k) return;
        var row = sizeFor(c, k, cm); if (!row) return;
        (groups[row.size] = groups[row.size] || []).push(c);
        if (!bra && row.bra) bra = row.bra;
      });
      var sizes = Object.keys(groups); if (!sizes.length) return { kind: "none" };
      sizes.sort(function (a, b) { return groups[b].length - groups[a].length || ORDER.indexOf(a) - ORDER.indexOf(b); });
      var maj = sizes[0], majRow = null;
      groups[maj].some(function (c) { var r = sizeFor(c, k, cm); if (r && r.bra) { majRow = r; return true; } return false; });
      return { kind: "size", size: maj, exceptions: sizes.slice(1).map(function (z) { return { size: z, names: groups[z].map(function (c) { return c.name; }) }; }), onesize: onesize, bra: majRow ? majRow.bra : bra };
    }
    function zonesHTML() { return '<div class="gbf-zones" role="group" aria-label="Type">' + Object.keys(ZKEY).map(function (z) { return '<button type="button" class="gbf-zone" data-zone="' + z + '" aria-pressed="' + (z === zone) + '">' + z + '</button>'; }).join("") + '</div>'; }
    function resultHTML() {
      var r = compute();
      if (r.kind === "empty") return "";
      if (r.kind === "none") return '<div class="gbf-result">' + csHTML(csUrl, "We don’t have a true size for that measurement.") + '</div>';
      var h = '<div class="gbf-result"><div class="gbf-size ff-heading">' + esc(r.size) + '</div><p class="gbf-line">Your size in our ' + ZNOUN[zone] + (r.exceptions.length ? ', with a few exceptions.' : '.') + '</p>';
      if (r.exceptions.length) h += '<ul class="gbf-exc">' + r.exceptions.map(function (e) { return '<li><b class="ff-heading">' + esc(e.size) + '</b> in the ' + esc(list(e.names)) + '</li>'; }).join("") + '</ul>';
      if (r.onesize.length && zone === "Bottoms") h += '<p class="gbf-other">Most of our thongs and tangas are one size.</p>';
      if (r.bra) h += '<p class="gbf-conv"><span>Roughly</span>' + esc(r.bra) + '</p>';
      return h + '</div>';
    }
    function render() {
      root.innerHTML = '<div class="gbf-row gbf-row--top"><span class="gbf-lab">I’m shopping for</span>' + unitsHTML(state) + '</div>' + zonesHTML() +
        '<div class="gbf-row"><span class="gbf-lab">Your measurements</span>' + fieldsHTML(state, ALL) + '</div><div class="gbf-out"></div>';
      root.querySelectorAll("[data-zone]").forEach(function (b) { b.addEventListener("click", function () { zone = b.getAttribute("data-zone"); render(); }); });
      bindTop(root, state, render, renderOut, extra);
      renderOut();
    }
    function renderOut() {
      var o = root.querySelector(".gbf-out"); if (!o) return;
      var r = compute();
      var sub = r.kind === "size" ? "We’ll skip this next time.<br>And send 10% off your first order. Optional." : "Save your measurements and we’ll remember them next time.<br>We’ll send 10% off your first order. Optional.";
      o.innerHTML = resultHTML() + noteHTML(state, ALL) + captureHTML(state, true, sub);
      bindOut(root, state, render, renderOut, extra);
      if (r.kind === "size") { clearTimeout(state._c); state._c = setTimeout(function () { stampCart({ _fit_finder_guide: zone + " " + r.size }); }, 1500); }
    }
    render();
  }

  window.GBFitFinder = {
    mountProduct: mountProduct, mountGuide: mountGuide, prep: prep,
    /* line-item properties for a product (by handle) — for cart adds done in JS */
    lineProps: function (handle) { var p = handle ? LINE_PROPS[handle] : LINE_PROPS[Object.keys(LINE_PROPS)[0]]; return Object.assign({}, p || {}); }
  };
})();
